import { nextTick } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import { auth } from "../firebase";
import { getIdTokenResult } from "firebase/auth";

const routes = [
  // ## LOGIN ##
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/loginView.vue"),
    meta: { requiresAuth: false, topbar: false },
  },
  {
    path: "/redirect-nightlyst",
    name: "Redirect nightlyst",
    component: () => import("../views/RedirectNightlyst.vue"),
    meta: { requiresAuth: false, topbar: false },
  },

  // ## EMPLOYEE HOME SECTION ##
  {
    path: "/",
    name: "Home",
    component: () => import("../views/homeView.vue"),
    meta: { requiresAuth: true, topbar: true },
  },

  // ## EMPLOYEE SECTION ##
  {
    path: "/event",
    name: "Events",
    component: () => import("../views/defaultView.vue"),
    meta: { requiresAuth: true, topbar: true },
    redirect: () => {
      return { path: "/event/list" };
    },
    children: [
      {
        path: "list",
        name: "Event List",
        component: () => import("../components/Employee/EventList.vue"),
      },
      {
        path: "detail/:id",
        name: "Event Detail",
        component: () => import("../components/Employee/EventDetail.vue"),
      },
      {
        path: ":id/guestlist/add",
        name: "Event Guestlist Create Entry",
        components: {
          default: () => import("../components/Employee/EventDetail.vue"),
          modal: () => import("../components/Employee/EventCreateGLEntry.vue"),
        },
      },
      {
        path: ":id/guestlist/:guestlistId/edit",
        name: "Event Guestlist Edit Entry",
        components: {
          default: () => import("../components/Employee/EventDetail.vue"),
          modal: () => import("../components/Employee/EventCreateGLEntry.vue"),
        },
      },
      {
        path: "checkin/:id",
        name: "Event Checkin",
        component: () => import("../components/Employee/EventCheckIn.vue"),
      },
      {
        path: "checkin/:id/:guestlistId",
        name: "Event Checkin Advanced",
        components: {
          default: () => import("../components/Employee/EventCheckIn.vue"),
          modal: () =>
            import("../components/Employee/EventCheckinEntourage.vue"),
        },
      },
    ],
  },

  // ## ADMIN SECTION ##
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/AdminView.vue"),
    meta: { requiresAuth: true, topbar: true, requiresAdmin: true },
    redirect: () => {
      return { path: "/admin/event/list" };
    },
    children: [
      {
        path: "event/list",
        name: "Admin Event List",
        component: () => import("../components/Admin/AdminEventList.vue"),
      },
      {
        path: "event/detail/:id",
        name: "Admin Event Detail",
        component: () => import("../components/Admin/AdminEventDetail.vue"),
      },
      {
        path: "event/create",
        name: "Admin Event Create",
        components: {
          default: () => import("../components/Admin/AdminEventList.vue"),
          modal: () => import("../components/Admin/AdminEventCreate.vue"),
        },
      },
      {
        path: "event/:id/edit",
        name: "Admin Event Edit",
        components: {
          default: () => import("../components/Admin/AdminEventDetail.vue"),
          modal: () => import("../components/Admin/AdminEventCreate.vue"),
        },
      },
      {
        path: "event/:id/guestlist/invite/create",
        name: "Admin Create Guestlist Invite",
        components: {
          default: () => import("../components/Admin/AdminEventDetail.vue"),
          modal: () => import("../components/Admin/AdminCreateGLInvite.vue"),
        },
      },
      {
        path: "event/:id/guestlist/invite/:inviteId/edit",
        name: "Admin Edit Guestlist Invite",
        components: {
          default: () => import("../components/Admin/AdminEventDetail.vue"),
          modal: () => import("../components/Admin/AdminCreateGLInvite.vue"),
        },
      },
      {
        path: "event/:id/friendslist/invite/create",
        name: "Admin Create Friendslist Invite",
        components: {
          default: () => import("../components/Admin/AdminEventDetail.vue"),
          modal: () => import("../components/Admin/AdminCreateFLInvite.vue"),
        },
      },
      {
        path: "event/:id/friendslist/invite/:inviteId/edit",
        name: "Admin Edit Friendslist Invite",
        components: {
          default: () => import("../components/Admin/AdminEventDetail.vue"),
          modal: () => import("../components/Admin/AdminCreateFLInvite.vue"),
        },
      },
      {
        path: "event/:id/friendslist/add",
        name: "Admin Create Friendslist Entry",
        components: {
          default: () => import("../components/Admin/AdminEventDetail.vue"),
          modal: () => import("../components/Admin/AdminCreateFLEntry.vue"),
        },
      },
      {
        path: "event/:id/friendslist/:friendslistId/edit",
        name: "Admin Edit Friendslist Entry",
        components: {
          default: () => import("../components/Admin/AdminEventDetail.vue"),
          modal: () => import("../components/Admin/AdminCreateFLEntry.vue"),
        },
      },
      {
        path: "event/:id/guestlist/add",
        name: "Admin Create Guestlist Entry",
        components: {
          default: () => import("../components/Admin/AdminEventDetail.vue"),
          modal: () => import("../components/Admin/AdminCreateGLEntry.vue"),
        },
      },
      {
        path: "event/:id/guestlist/:guestlistId/edit",
        name: "Admin Edit Guestlist Entry",
        components: {
          default: () => import("../components/Admin/AdminEventDetail.vue"),
          modal: () => import("../components/Admin/AdminCreateGLEntry.vue"),
        },
      },
      {
        path: "user/create",
        name: "User Create",
        components: {
          default: () => import("../components/Admin/AdminUserList.vue"),
          modal: () => import("../components/Admin/AdminUserCreate.vue"),
        },
      },
      {
        path: "user/list",
        name: "User Management",
        component: () => import("../components/Admin/AdminUserList.vue"),
      },
    ],
  },

  // ## INVITE SECTION ##
  {
    path: "/guestlist/invite",
    name: "Guestlist",
    component: () => import("../views/inviteView.vue"),
    meta: { requiresAuth: false, topbar: false },
    children: [
      {
        path: ":id",
        name: "Guestlist invite",
        component: () => import("../components/Invite/InviteGuestList.vue"),
      },
      {
        path: ":id/entry/add",
        name: "Create Guestlist invite Entry",
        components: {
          default: () => import("../components/Invite/InviteGuestList.vue"),
          modal: () =>
            import("../components/Invite/InviteGuestListCreateEntry.vue"),
        },
      },
      {
        path: ":id/entry/:guestlistId/edit",
        name: "Edit Guestlist Invite Entry",
        components: {
          default: () => import("../components/Invite/InviteGuestList.vue"),
          modal: () =>
            import("../components/Invite/InviteGuestListCreateEntry.vue"),
        },
      },
    ],
  },

  // ## FRIENDSLIST INVITES ##
  {
    path: "/friendslist/invite",
    name: "Invites",
    component: () => import("../views/inviteView.vue"),
    meta: { requiresAuth: false, topbar: false },
    children: [
      // ## FRIENDSLIST INVITES ##
      {
        path: ":id/",
        name: "Friendslist invite",
        component: () => import("../components/Invite/InviteFriendsList.vue"),
      },
      {
        path: ":id/entry/add",
        name: "Create Friendslist invite Entry",
        components: {
          default: () => import("../components/Invite/InviteFriendsList.vue"),
          modal: () =>
            import("../components/Invite/InviteFriendsListCreateEntry.vue"),
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "404 Page not found",
    component: () => import("../views/notFound.vue"),
  },
];

// ## Create router ##
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// ## ROUTER GUARD ##
router.beforeEach(async (to) => {

  let path = to.path.split("/")[1];
  if(path !== "redirect-nightlyst")
  return {
    path: "/redirect-nightlyst",
  };



  //Get current user from firebase
  var firebaseuser = await auth.getCurrentUser();
  var firebaseIdToken = {};

  if (firebaseuser) {
    //Get claims from firebase
    firebaseIdToken = await getIdTokenResult(firebaseuser);
  }

  if (to.meta.requiresAuth && !firebaseuser) {
    return {
      path: "login",
      query: { redirect: to.fullPath },
    };
  } else if (
    to.meta.requiresAdmin &&
    firebaseuser &&
    !firebaseIdToken.claims.admin
  ) {
    return {
      path: "/",
    };
  } else if (path == "" && firebaseIdToken.claims.admin) {
    return {
      path: "/admin/event/list",
    };
  } else if (path == "") {
    return {
      path: "/event/list",
    };
  }
  //Scroll to top on new window
  window.scrollTo(0, 0);
});

router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  nextTick(() => {
    document.title = to.name || "DEFAULT_TITLE";
  });
});

export default router;
